import { envConfig } from "@env/env-config";
import { IReCaptcha } from "./recaptcha";

export class GReCaptcha implements IReCaptcha {

    public static readonly $inject: Array<string> = ["$q"];

    constructor(private $q: angular.IQService) { }

    /**
     * @param {object} params
     * @param {Function} callback
     * @return {*}
     */
    public getReCaptcha(params: { action: string }, callback?: Function): angular.IPromise<string> {
        let siteKey = envConfig.googleRecaptchaSecretKey();

        let defer = this.$q.defer<string>();

        if (window.grecaptcha == null || window.grecaptcha == undefined) {
            defer.reject({
                successs: false,
                code: "",
                message: "We need to use google reCaptcha in this page, but it seem that you can not connect to google."
            });
        } else {
            window.grecaptcha.ready(() => {
                window.grecaptcha.execute(siteKey, { action: params.action }).then((token) => {
                    defer.resolve(token);
                }, (failResp) => {
                    defer.reject(failResp);
                })
            })
        }

        return defer.promise;
    }
}